import { render, staticRenderFns } from "./RegisterProduction.vue?vue&type=template&id=9a956f38&"
import script from "./RegisterProduction.vue?vue&type=script&lang=js&"
export * from "./RegisterProduction.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProduction.vue?vue&type=style&index=0&id=9a956f38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports